import { useQuery } from 'hooks/useCustomQuery';
import getServiceCategory from 'API/ServiceCategories/getServiceCategory';

const useGetServiceCategory = (serviceCategoryId, enabled = true) => {
    return useQuery({
        queryKey: ['ServiceCategory', serviceCategoryId],
        queryFn: async () => {
            const response = await getServiceCategory(serviceCategoryId);
            return response.data;
        },
        enabled: enabled && !!serviceCategoryId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetServiceCategory;
